module.exports = __webpack_public_path__ + "static/media/MoederAkt.8c725d1b.jpg";